const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4000' 
  : '';

// Helper function to get auth headers
export const getAuthHeaders = async (getToken) => {
  const token = await getToken();
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Helper function for authenticated fetch
export const authenticatedFetch = async (url, options = {}, getToken) => {
  const token = await getToken();
  const headers = {
    'Authorization': `Bearer ${token}`,
    ...options.headers
  };

  return fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers
  });
};

export { API_BASE_URL };

